import Component from '../../abstracts/Component';

export default class ModalMixinComponent extends Component {
  get SELECTORS() {
    return {
        hideCta: '[data-modal-hide-cta]',
    };
  }

  get CSS() {
    return {
        shown: '--shown'
    };
  }

  constructor(elem) {
    super(elem);
    this.hide = this.hide.bind(this);
    this.show = this.show.bind(this);
  }

  readDOM() {
    return {
        hideCtas: this.$component.querySelectorAll(this.SELECTORS.hideCta),
    }
  }

  render() {
    this.dom = this.readDOM();
    this.bindEvents();
  }

  bindEvents() {
    this.dom.hideCtas.forEach(e => {
        e.addEventListener('click', () => {
            this.hide();
        });
    });
  }

  // API
  hide() {
    this.$component.classList.remove(this.CSS.shown);
    this.emit(this.$customEvents.MODAL.hide);
  }

  show() {
    this.$component.classList.add(this.CSS.shown);
    this.emit(this.$customEvents.MODAL.show);
  }

  isShown() {
    return this.$component.classList.contains(this.CSS.shown);
  }
}
